import { jsx as _jsx } from "react/jsx-runtime";
import { useTasksJobs } from '../hooks/useTasksJobs';
import { TasksDrawer } from '../TasksDrawer/TasksDrawer';
import { useAutoOpenDrawer } from './hooks/useAutoOpenDrawer';
import { useCompletionToast } from './hooks/useCompletionToast';
import { useRelationshipPdfChannelBinder } from './hooks/useRelationshipPdfChannelBinder';
export const TasksDrawerRoot = ()=>{
    useTasksJobs({
        refreshOnHookMount: true
    });
    useRelationshipPdfChannelBinder();
    useCompletionToast();
    useAutoOpenDrawer();
    return /*#__PURE__*/ _jsx(TasksDrawer, {});
};
